export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-selection/src/constant.js
// module id = 230
// module chunks = 0